import axios from "axios";
import Client from "myinsights-sf-client";

function errorHandler(error) {
  return new Promise((resolve, reject) => {
    reject(error);
  });
}

const CDE_DATA_ENDPOINT = "/api/v1/data";
const CDE_TABLES_ENDPOINT = "/api/v1/tables";

class CRMDataEngine {
  cdeEngineUrl = null;

  constructor(crmURL, crmVersion, sfEndpoint, sfSession, orgId) {
    this._crmURL = crmURL;
    this._crmVersion = crmVersion;
    this._sfEndpoint = sfEndpoint;
    this._sfSession = sfSession;
    this._orgId = orgId;
  }

  getCdeServerUrl() {
    if (this.cdeEngineUrl === null) {
      const options = {
        headers: { sfEndpoint: this._sfEndpoint, sfSession: this._sfSession }
      };
      const MISFClient = new Client(this._sfEndpoint, this._sfSession);
      return MISFClient.sfClient.apex
        .get("/veeva/settings/common", options)
        .then(configs => {
          const veevaCommon = configs.find(c => {
            return c.name === "Veeva_Common_vod__c";
          });
          this.cdeEngineUrl = this.sanitizeUrl(veevaCommon.data["CDE_Server_vod__c"]);
          return this.cdeEngineUrl;
        }, errorHandler);
    } else {
      return this.cdeEngineUrl;
    }
  }

  sanitizeUrl(cdeUrl) {
    let sanitizedUrl = "";
    if (cdeUrl) {
      sanitizedUrl = cdeUrl.trim();
    }
    if (sanitizedUrl.length > 0 && sanitizedUrl.charAt(sanitizedUrl.length - 1) === '/') {
      sanitizedUrl = sanitizedUrl.substring(0, sanitizedUrl.length - 1);
    }
    return sanitizedUrl;
  }

  async queryDataEngine(configObject) {
    const cdeServerURL = await this.getCdeServerUrl();
    const url = `${cdeServerURL}${CDE_DATA_ENDPOINT}`;

    const config = {
      headers: {
        sfEndpoint: this._sfEndpoint
      }
    };

    return axios.post(url, configObject, config).then(resp => {
      if (resp.data && resp.data.status === "SUCCESS") {
        return resp.data;
      } else {
        throw {
          name: "APIRequestError",
          message: "API request was not successful"
        };
      }
    }, errorHandler);
  }

  async getDataEngineTables() {
    const cdeServerURL = await this.getCdeServerUrl();
    const url = `${cdeServerURL}${CDE_TABLES_ENDPOINT}`;

    const config = {
      headers: {
        sfEndpoint: this._sfEndpoint
      }
    };

    return axios.get(url, config).then(resp => {
      if (resp.data && resp.data.status === "SUCCESS") {
        return {
          data: resp.data.data,
          success: true
        };
      } else {
        throw {
          name: "APIRequestError",
          message: "API request was not successful"
        };
      }
    }, errorHandler);
  }

  async getDataEngineTableMetadata(configObj) {
    const cdeServerURL = await this.getCdeServerUrl();
    const url = `${cdeServerURL}${CDE_TABLES_ENDPOINT}/${configObj.tableName}`;

    const config = {
      headers: {
        sfEndpoint: this._sfEndpoint
      }
    };

    return axios.get(url, config).then(resp => {
      if (resp.data && resp.data.status === "SUCCESS") {
        return {
          data: resp.data.data.columns,
          success: true
        };
      } else {
        throw {
          name: "APIRequestError",
          message: "API request was not successful"
        };
      }
    }, errorHandler);
  }

  getAlignedTerritories(queryConfig) {
    const config = {
      headers: {
        sfEndpoint: this._sfEndpoint,
        sfSession: this._sfSession
      }
    };

    const includeChildren = queryConfig.includeChildren;

    const MISFClient = new Client(this._sfEndpoint, this._sfSession);
    const urlToCall =
      "/veeva/territory/user-territory?" +
      new URLSearchParams({ includeChildren: includeChildren });

    return MISFClient.sfClient.apex.get(urlToCall, config).then(resp => {
      if (resp && Array.isArray(resp)) {
        const r = resp.map(territory => {
          return {
            description: territory.Description ?? null,
            developerName: territory.DeveloperName,
            parentTerritoryId: territory.ParentTerritoryId ?? null,
            name: territory.Name,
            id: territory.Id
          };
        });

        return { data: r, success: true };
      } else {
        throw {
          name: "APIRequestError",
          message: "API request was not successful"
        };
      }
    }, errorHandler);
  }
}

export default CRMDataEngine;
